import { Paper, TablePagination } from "@mui/material";

const DataTablePagination = ({
  isMobile,
  dataList,
  paginationInfo,
  currentPage,
  handlePageChange,
  rowsPerPage,
  handleRowsPerPageChange,
}) =>
  dataList.length > 0 &&
  paginationInfo.totalPages > 0 && (
    <Paper
      sx={{
        p: 0.5,
        backgroundColor: "#fff",
        border: "1px solid #E6ECEA",
        boxShadow: "none",
        borderRadius: 3,
        mt: 2,
      }}
    >
      <TablePagination
        component="div"
        count={paginationInfo.totalCount}
        page={currentPage}
        onPageChange={handlePageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={isMobile ? [5, 10, 25, 50] : [5, 10, 25, 50, 100]}
        sx={{
          "& .MuiTablePagination-toolbar": { px: 0 },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              color: "#66766F",
              fontSize: 13,
            },
          "& .MuiTablePagination-select": {
            color: "#12181A",
            fontWeight: 600,
          },
          "& .MuiIconButton-root": {
            borderRadius: 2,
            color: "#66766F",
            "&:hover": {
              backgroundColor: "#E6F5F2",
              color: "#0B5F56",
            },
          },
        }}
      />
    </Paper>
  );

export default DataTablePagination;
